import { ROUTES } from 'module/navigation/enums/routes.enums';
import { getPermissionAwareDetailLocation } from 'core/utils/permissionAwareNavigation';

export type TodoNavigationState = {
	returnTo?: string;
};

export type TodoDetailLocationOptions = {
	returnTo?: string;
	canEdit?: boolean;
};

export const getTodoDetailLocation = (
	id: number | string,
	options: TodoDetailLocationOptions = {},
): { pathname: string; state?: TodoNavigationState } => {
	const { returnTo, canEdit = false } = options;
	return getPermissionAwareDetailLocation({
		id,
		canEdit,
		editPath: ROUTES.EDIT_TO_DO,
		viewPath: ROUTES.TO_DO_ID,
		returnTo,
	});
};

export const getTodoScheduleDetailLocation = (
	id: number | string,
	options: { canEdit?: boolean } = {},
): { pathname: string } => {
	const { canEdit = false } = options;
	return getPermissionAwareDetailLocation({
		id,
		canEdit,
		editPath: ROUTES.EDIT_TO_DO_SCHEDULE,
		viewPath: ROUTES.VIEW_TO_DO_SCHEDULE,
	});
};

export const resolveTodoReturnPath = (
	state: unknown,
	fallback: string = ROUTES.TO_DO,
): string => {
	if (state && typeof state === 'object' && 'returnTo' in state) {
		const returnTo = (state as TodoNavigationState).returnTo;
		if (typeof returnTo === 'string' && returnTo.trim() !== '') {
			return returnTo;
		}
	}
	return fallback;
};
